(function () {
  'use strict';

  var component = {
    template:'<div class="hq-lighting-modal"><button hq-tools-lighting-focus-on="modal-close" ng-click="$ctrl.closeModal()" class="hq-lighting-modal__close">{{\'CLOSE_INFORMATION\' | translate}}</button><div class="hq-lighting-modal__content" translate="{{$ctrl.translateKey}}"></div></div>',
    bindings: {
      translateKey: '@',
      closeModal: '&',
    },
  };

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingModal', component);
}());
